import React from 'react';

const CareerOpportunities = React.lazy(() => import('pages/CareerOpportunities'));
const Policy = React.lazy(() => import('pages/About/Policy'));
const Achievement = React.lazy(() => import('pages/About/Achievement'));
const AnalysisReport = React.lazy(() => import('pages/OrganizationalCustomers/AnalysisReport'));
const Introduction = React.lazy(() => import('pages/About/Introduction'));
const BranchNetwork = React.lazy(() => import('pages/About/BranchNetwork'));
const OrganizationChart = React.lazy(() => import('pages/About/OrganizationChart'));
const AboutLeader = React.lazy(() => import('pages/About/Council'));
const Home = React.lazy(() => import('pages/Home'));
const ContactUs = React.lazy(() => import('pages/ContactUs'));
const TradingGuide = React.lazy(() => import('pages/TransactionSupport/TradingGuide'));
const ValuesVisionGoals = React.lazy(() => import('pages/About/ValuesVisionGoals'));
const About = React.lazy(() => import('pages/About/'));
const StockTrading = React.lazy(() => import('pages/IndividualCustomers/StockTrading'));
const EntrustedAccount = React.lazy(() => import('pages/IndividualCustomers/EntrustedAccount'));
const InvestmentAdvising = React.lazy(() => import('pages/IndividualCustomers/InvestmentAdvising'));
const Questions = React.lazy(() => import('pages/TransactionSupport/Questions'));
const RecentDeals = React.lazy(() => import('pages/InvestmentBank/RecentDeals'));
const ProductServiceGuide = React.lazy(() => import('pages/TransactionSupport/ProductServiceGuide'));
const Maintenance = React.lazy(() => import('pages/Errors/error403'));
const Tariff = React.lazy(() => import('pages/TransactionSupport/Tariff'));
const ReportYearly = React.lazy(() => import('pages/News/ReportYearly'));
const NewsAndEvent = React.lazy(() => import('pages/News/NewsAndEvent'));
const VideoPage = React.lazy(() => import('pages/News/Video/video'));
const ManagementReport = React.lazy(() => import('pages/News/ManagementReport'));
const FinanceReport = React.lazy(() => import('pages/News/Report'));
const EventSchedule = React.lazy(() => import('pages/News/EventSchedule'));
const RmJoinReason = React.lazy(() => import('pages/RmJoinReason'));
const RecruitmentOverview = React.lazy(() => import('pages/RecruitmentOverview'));
const BondCategory = React.lazy(() => import('pages/IndividualCustomers/BondCategory'));
const DefaultTransactionSupport = React.lazy(() => import('pages/TransactionSupport/Default'));

export type TemplateCodeType = {
  code: string;
  component: React.FC<BasePageDataTypes<any>>;
};

// MainLayout
export const TemplateCodes: TemplateCodeType[] = [
  {
    code: 'HOME',
    component: Home,
  },
  {
    code: 'ABOUT_GENERAL',
    component: Introduction,
  },
  {
    code: 'ABOUT_OVERVIEW',
    component: About,
  },
  {
    code: 'ABOUT_NETWORK',
    component: BranchNetwork,
  },
  {
    code: 'ABOUT_ORGANIZATIONAL_CHART',
    component: OrganizationChart,
  },
  {
    code: 'ABOUT_LEADER',
    component: AboutLeader,
  },
  {
    code: 'ABOUT_ACHIEVEMENT',
    component: Achievement,
  },
  {
    code: 'ABOUT_VALUE',
    component: ValuesVisionGoals,
  },
  {
    code: 'ABOUT_POLICY',
    component: Policy,
  },
  {
    code: 'CONTACT',
    component: ContactUs,
  },
  {
    code: 'KHCN_STOCK_TRADING',
    component: StockTrading,
  },
  {
    code: 'HTGD_FEATURES_LIST',
    component: StockTrading,
  },
  {
    code: 'KHCN_ACCOUNT_MANAGEMENT',
    component: EntrustedAccount,
  },
  {
    code: 'KHCN_INVESTMENT_CONSULTING',
    component: InvestmentAdvising,
  },
  {
    code: 'KHCN_FAQ',
    component: Questions,
  },
  {
    code: 'KHCN_FAQ_1',
    component: Questions,
  },
  {
    code: 'HTGH_GUIDE_TRADING_SYSTEM',
    component: TradingGuide,
  },
  {
    code: 'NHDT_RECENT_DEAL',
    component: RecentDeals,
  },
  {
    code: 'HTGD_PRODUCTS_AND_SERVICES',
    component: ProductServiceGuide,
  },
  {
    code: 'HTGD_BUSINESS',
    component: Tariff,
  },
  {
    code: 'NEWS_CORPORATE_GOVERNANCE_SITUATION',
    component: ManagementReport,
  },
  {
    code: 'ERROR_403',
    component: Maintenance,
  },
  {
    code: 'KHCN_ANALYSIS_REPORT',
    component: AnalysisReport,
  },
  {
    code: 'NEWS_VIDEOS',
    component: VideoPage,
  },
  {
    code: 'NEWS_ANNUAL_REPORT',
    component: ReportYearly,
  },
  {
    code: 'NEWS_VCBS_NEWS_EVENTS',
    component: NewsAndEvent,
  },
  {
    code: 'NEWS_FINANCIAL_STATEMENTS',
    component: FinanceReport,
  },
  {
    code: 'NEWS_CALENDAR_EVENTS',
    component: EventSchedule,
  },
  {
    code: 'TPDN',
    component: BondCategory,
  },
  {
    code: 'HTGD_DEFAULT_TEMPLATE',
    component: DefaultTransactionSupport,
  },
];

// Recruitment layout
export const RecruitTemplateCodes: TemplateCodeType[] = [
  {
    code: 'RECRUITMENT',
    component: RecruitmentOverview,
  },
  {
    code: 'RECRUITMENT_CAREER',
    component: CareerOpportunities,
  },
  {
    code: 'RECRUITMENT_ABOUT_US',
    component: RmJoinReason,
  },
];
